import * as React from 'react'

import { cn } from '@/lib/utils'

export interface StepCardProps {
  /** Two-digit step number, e.g. "01". Caller formats the padding. */
  number: string
  title: string
  children: React.ReactNode
  className?: string
}

/**
 * Numbered onboarding step. Dark-surface only — uses a near-transparent
 * white fill, so it assumes a dark ancestor background (see DataCard,
 * which is its usual grid neighbor).
 */
export function StepCard({ number, title, children, className }: StepCardProps) {
  return (
    <div
      className={cn(
        'flex min-h-[200px] flex-col gap-4 rounded-sm border border-white/12 bg-white/2 px-6 py-8 text-white',
        className
      )}
    >
      <div className="text-brand-300 border-b border-white/12 pb-4 font-mono text-sm font-semibold tracking-[0.08em]">
        {number}
      </div>
      <h3 className="text-2xl font-bold tracking-[-0.01em]">{title}</h3>
      <p className="text-md leading-[1.55] text-white/66">{children}</p>
    </div>
  )
}
